import { apiRequest } from '../../../api/client';
import type { Incident, IncidentFilters, IncidentPage } from '../../../api/types';

// PARA-129, AC-18/AC-19: все фильтры опциональны, limit/offset — обязательная
// пагинация (backend отклоняет limit выше жёсткого максимума с 422).
export async function fetchIncidents(filters: IncidentFilters): Promise<IncidentPage> {
  const params = new URLSearchParams();
  if (filters.date_from) params.set('date_from', filters.date_from);
  if (filters.date_to) params.set('date_to', filters.date_to);
  if (filters.severity) params.set('severity', filters.severity);
  if (filters.category) params.set('category', filters.category);
  if (filters.incident_type) params.set('incident_type', filters.incident_type);
  if (filters.acknowledged !== undefined) params.set('acknowledged', String(filters.acknowledged));
  if (filters.limit !== undefined) params.set('limit', String(filters.limit));
  if (filters.offset !== undefined) params.set('offset', String(filters.offset));

  const query = params.toString();
  return apiRequest<IncidentPage>(`/admin/incidents${query ? `?${query}` : ''}`);
}

export async function fetchIncident(incidentId: number): Promise<Incident> {
  return apiRequest<Incident>(`/admin/incidents/${incidentId}`);
}

// AC-17: идемпотентно — повторный вызов возвращает те же acknowledged_by/at.
export async function acknowledgeIncident(incidentId: number): Promise<Incident> {
  return apiRequest<Incident>(`/admin/incidents/${incidentId}/acknowledge`, {
    method: 'POST',
  });
}
